export enum Company{
    None = 0,
    CINC = 1,
    RealGeeks = 2
}